import { api } from "./http-client";
import {
  FacebookListingListResponse,
  ListingListResponse,
  ListingPageOptionsDto,
  WhatsappListingListResponse,
  WhatsappListingPageOptionsDto,
} from "../types/listing";

export const listingsService = {
  async list(params?: ListingPageOptionsDto): Promise<ListingListResponse> {
    const response = await api.request<ListingListResponse>({
      url: "/listings",
      method: "GET",
      params,
    });
    return response.data;
  },
  async listWhatsapp(
    params?: WhatsappListingPageOptionsDto,
  ): Promise<WhatsappListingListResponse> {
    const response = await api.request<WhatsappListingListResponse>({
      url: "/listings/whatsapp",
      method: "GET",
      params,
    });
    return response.data;
  },
  async listFacebook(
    params?: WhatsappListingPageOptionsDto,
  ): Promise<FacebookListingListResponse> {
    const response = await api.request<FacebookListingListResponse>({
      url: "/listings/facebook",
      method: "GET",
      params,
    });
    return response.data;
  },
  async updateMatch(id: string, data: { matchedCardId?: string; matchedBy?: string }) {
    const response = await api.request({
      url: `/listings/${id}`,
      method: "PATCH",
      data,
    });
    return response.data;
  },
};

